export const onGoingDelegationRows = [
  {
    validator: 'John Cash',
    status: 'OPEN',
    timeLeft: '3 Days',
    spaceLeft: '12000',
    estimated: '15'
  },
  {
    validator: 'John Weeck',
    status: 'CLOSED',
    timeLeft: '5 Days',
    spaceLeft: '12500',
    estimated: '8'
  },
  {
    validator: 'Melvin Bryna',
    status: 'OPEN',
    timeLeft: '6 Days',
    spaceLeft: '46378',
    estimated: '13'
  },
  {
    validator: 'Andrew Marcello',
    status: 'OPEN',
    timeLeft: '8 Days',
    spaceLeft: '165',
    estimated: '21'
  },
  {
    validator: 'Johnny Stephen',
    status: 'OPEN',
    timeLeft: '12 Days',
    spaceLeft: '270',
    estimated: '8'
  },
  {
    validator: 'John Cash',
    status: 'OPEN',
    timeLeft: '3 Days',
    spaceLeft: '12000',
    estimated: '15'
  },
  {
    validator: 'John Weeck',
    status: 'OPEN',
    timeLeft: '5 Days',
    spaceLeft: '12500',
    estimated: '8'
  },
  {
    validator: 'Melvin Bryna',
    status: 'OPEN',
    timeLeft: '6 Days',
    spaceLeft: '46378',
    estimated: '13'
  }
];

export const completedDelegationRows = [
  {
    validator: 'Melvin Bryna',
    estimated: '1',
    total: '34',
    rewards: '12000'
  },
  {
    validator: 'John Seek',
    estimated: '25',
    total: '6',
    rewards: '8600'
  },
  {
    validator: 'John Trawolta',
    estimated: '25',
    total: '7',
    rewards: '12070'
  },
  {
    validator: 'John Weck',
    estimated: '25',
    total: '19',
    rewards: '13050'
  },
  {
    validator: 'John Cash',
    estimated: '25',
    total: '29',
    rewards: '3700'
  },
  {
    validator: 'Andrew Marcello',
    estimated: '25',
    total: '47',
    rewards: '5400'
  },
  {
    validator: 'Britney Howard',
    estimated: '25',
    total: '34',
    rewards: '9200'
  },
  {
    validator: 'Johnny Stephen',
    estimated: '25',
    total: '24',
    rewards: '9000'
  }
];
